import { render, staticRenderFns } from "./mediaSpec_similarArticle.vue?vue&type=template&id=645cca8e&"
import script from "./mediaSpec_similarArticle.vue?vue&type=script&lang=js&"
export * from "./mediaSpec_similarArticle.vue?vue&type=script&lang=js&"
import style0 from "./mediaSpec_similarArticle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports